import type { ConversationNodeClose } from 'lib-shared-types-api';

type Props = {
  node: ConversationNodeClose;
};

export function RoutedThroughClose(_: Props): JSX.Element {
  return <>Close conversation</>;
}
